export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/magento.130536d.svg";